import { render, staticRenderFns } from "./bscOrderXietong.vue?vue&type=template&id=a89143ae&scoped=true"
import script from "./bscOrderXietong.vue?vue&type=script&lang=js"
export * from "./bscOrderXietong.vue?vue&type=script&lang=js"
import style0 from "./bscOrderXietong.vue?vue&type=style&index=0&id=a89143ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89143ae",
  null
  
)

export default component.exports